// WhatsApp deep links — the client's phone sends, so this stays free.
export function waNumber(p) {
  let n = String(p || '').replace(/\D/g, '');
  if (!n) return '';
  if (n.startsWith('0')) n = '60' + n.slice(1);
  else if (!n.startsWith('60')) n = '60' + n;
  return n;
}
export function waOpen(phone, text) {
  const n = waNumber(phone);
  if (!n) { alert('No phone number on this patient.'); return; }
  window.open('https://wa.me/' + n + '?text=' + encodeURIComponent(text), '_blank');
}

const BIZ = 'Assura Nursing Care';
export const msg = {
  confirm: (name, shiftInfo = '') =>
    `Hi${name ? ' ' + name : ''}, this is ${BIZ} 🌿 We're glad to take your case and will confirm the visit details with you shortly.${shiftInfo ? ' ' + shiftInfo : ''} `
    + `\n\n您好${name ? ' ' + name : ''}，这里是 ${BIZ}。我们很乐意为您服务，稍后将与您确认上门详情。`,
  
  autoReply: (name, opts = {}) => {
    const shift = opts.shift || 'AM';
    const preferredTime = opts.time || opts.preferredTime || '';
    const careType = opts.careType || 'Home Nursing Care';
    const isOneTime = opts.isOneTime || shift === 'ONETIME' || !!preferredTime;
    
    let timeLineEn = '';
    let timeLineZh = '';
    if (isOneTime && preferredTime) {
      timeLineEn = `⏰ Scheduled Procedure Time: ${preferredTime} (Family Preferred Time)`;
      timeLineZh = `⏰ 预约上门时间：${preferredTime}（家属指定时间）`;
    } else if (shift === 'PM') {
      timeLineEn = `⏰ Scheduled Shift: PM Shift (15:00 – 22:00)`;
      timeLineZh = `⏰ 护理班次：下午班 PM (15:00 – 22:00)`;
    } else if (shift === 'NIGHT' || shift === 'N') {
      timeLineEn = `⏰ Scheduled Shift: Night (N) Shift (22:00 – 08:00)`;
      timeLineZh = `⏰ 护理班次：夜班 Night (22:00 – 08:00)`;
    } else {
      timeLineEn = `⏰ Scheduled Shift: AM Shift (08:00 – 15:00)`;
      timeLineZh = `⏰ 护理班次：早班 AM (08:00 – 15:00)`;
    }

    return `Salam & Good day${name ? ' ' + name : ''} 🌿\n\n`
      + `Thank you for reaching out to ${BIZ} Penang. We have safely received your request for ${careType}.\n\n`
      + `${timeLineEn}\n`
      + `👩‍⚕️ Quality & Governance Guarantee:\n`
      + `• 100% Malaysian Nursing Board (LJM) Registered Nurses with valid Annual Practicing Certificates (APC)\n`
      + `• Hospital-grade sterile consumables & MOH ANTT aseptic technique\n`
      + `• Digital MEWS vital monitoring & clinical handover for every visit\n\n`
      + `Our on-duty Clinical Coordinator (Sister Tan / Nurse Farah) is reviewing your case details and will contact you within 15–30 minutes to confirm arrangements.\n\n`
      + `Emergency Notice: For acute life-threatening emergencies (severe chest pain, respiratory distress, acute stroke), please dial 999 immediately.\n\n`
      + `────────────────────\n`
      + `您好${name ? ' ' + name : ''}，${BIZ} 槟城专业上门护理已收到您的预约申请。\n`
      + `${timeLineZh}\n`
      + `我们的持证护士（LJM Registered / 具备有效 APC）正为您准备护理方案，护士主管将在 15–30 分钟内与您联系确认详情。\n\n`
      + `Assura Nursing Care Penang · 24/7 Hotline: 012-206 4868`;
  },

  decline: (name) =>
    `Hi${name ? ' ' + name : ''}, thank you for reaching out to ${BIZ}. Unfortunately we're unable to take this case at the moment. `
    + `We're happy to suggest where else you might get help if useful. `
    + `\n\n您好${name ? ' ' + name : ''}，感谢您联系 ${BIZ}。很抱歉，我们目前无法接下此个案。如有需要，我们乐意为您提供其他建议。`,
  
  followup: (name) =>
    `Hi${name ? ' ' + name : ''}, checking in from ${BIZ} 🌿 How is everything since our last visit? Let us know if you'd like to arrange the next one. `
    + `\n\n您好${name ? ' ' + name : ''}，${BIZ} 关心您。自上次上门后一切可好？如需安排下次探访，请告诉我们。`,
};

